//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ExternalDataSourcesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type ExternalDataSourcesSetEnabledExternalDataSourcesQueryParameters = {
  dataSource: Types.DataSource ;
}

export type ExternalDataSourcesSetPriorityExternalDataSourcesQueryParameters = {
  dataSource: Types.DataSource ;
}

export function externalDataSourcesGetListUrl(): string {
  let url_ = getBaseUrl() + "/api/external/data-sources";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let externalDataSourcesGetListDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfExternalDataSourceDto, unknown, Types.ListResultDtoOfExternalDataSourceDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfExternalDataSourceDto, unknown, Types.ListResultDtoOfExternalDataSourceDto>, 'queryFn'>> = {
};
export function getExternalDataSourcesGetListDefaultOptions() {
  return externalDataSourcesGetListDefaultOptions;
};
export function setExternalDataSourcesGetListDefaultOptions(options: typeof externalDataSourcesGetListDefaultOptions) {
  externalDataSourcesGetListDefaultOptions = options;
}

export function externalDataSourcesGetListQueryKey(): QueryKey;
export function externalDataSourcesGetListQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'ExternalDataSourcesClient',
      'externalDataSourcesGetList',
    ]);
}
export function __externalDataSourcesGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.externalDataSourcesGetList(
axiosConfig    );
}

/**
 * @return OK
 */
export function useExternalDataSourcesGetListQuery<TSelectData = Types.ListResultDtoOfExternalDataSourceDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfExternalDataSourceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExternalDataSourcesGetListQuery<TSelectData = Types.ListResultDtoOfExternalDataSourceDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfExternalDataSourceDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfExternalDataSourceDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __externalDataSourcesGetList(context, axiosConfig) : __externalDataSourcesGetList,
    queryKey: externalDataSourcesGetListQueryKey(),
    ...externalDataSourcesGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfExternalDataSourceDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setExternalDataSourcesGetListData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfExternalDataSourceDto | undefined) => Types.ListResultDtoOfExternalDataSourceDto, ) {
  queryClient.setQueryData(externalDataSourcesGetListQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setExternalDataSourcesGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfExternalDataSourceDto | undefined) => Types.ListResultDtoOfExternalDataSourceDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function externalDataSourcesSetEnabledUrl(dataSource: Types.DataSource): string {
  let url_ = getBaseUrl() + "/api/external/data-sources/{dataSource}";
if (dataSource === undefined || dataSource === null)
  throw new Error("The parameter 'dataSource' must be defined.");
url_ = url_.replace("{dataSource}", encodeURIComponent("" + dataSource));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalDataSourcesSetEnabledMutationKey(dataSource: Types.DataSource): MutationKey {
  return trimArrayEnd([
      'ExternalDataSourcesClient',
      'externalDataSourcesSetEnabled',
      dataSource as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalDataSourcesSetEnabledMutation<TContext>(dataSource: Types.DataSource, options?: Omit<UseMutationOptions<void, unknown, Types.ExternalDataSourceSetEnabledInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ExternalDataSourceSetEnabledInput, TContext> {
  const key = externalDataSourcesSetEnabledMutationKey(dataSource);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ExternalDataSourceSetEnabledInput) => Client.externalDataSourcesSetEnabled(dataSource, body),
    mutationKey: key,
  });
}
  
type ExternalDataSourcesSetEnabled__MutationParameters = ExternalDataSourcesSetEnabledExternalDataSourcesQueryParameters & {
  body: Types.ExternalDataSourceSetEnabledInput;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalDataSourcesSetEnabledMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ExternalDataSourcesSetEnabled__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalDataSourcesSetEnabledExternalDataSourcesQueryParameters}): UseMutationResult<void, unknown, ExternalDataSourcesSetEnabled__MutationParameters, TContext> {
  const key = externalDataSourcesSetEnabledMutationKey(options?.parameters?.dataSource!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalDataSourcesSetEnabled__MutationParameters) => Client.externalDataSourcesSetEnabled(data.dataSource ?? options?.parameters?.dataSource!, data.body),
  mutationKey: key,
});
}
  
export function externalDataSourcesSetPriorityUrl(dataSource: Types.DataSource): string {
  let url_ = getBaseUrl() + "/api/external/data-sources/{dataSource}/priority";
if (dataSource === undefined || dataSource === null)
  throw new Error("The parameter 'dataSource' must be defined.");
url_ = url_.replace("{dataSource}", encodeURIComponent("" + dataSource));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalDataSourcesSetPriorityMutationKey(dataSource: Types.DataSource): MutationKey {
  return trimArrayEnd([
      'ExternalDataSourcesClient',
      'externalDataSourcesSetPriority',
      dataSource as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalDataSourcesSetPriorityMutation<TContext>(dataSource: Types.DataSource, options?: Omit<UseMutationOptions<void, unknown, Types.ExternalDataSourceSetPriorityInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ExternalDataSourceSetPriorityInput, TContext> {
  const key = externalDataSourcesSetPriorityMutationKey(dataSource);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ExternalDataSourceSetPriorityInput) => Client.externalDataSourcesSetPriority(dataSource, body),
    mutationKey: key,
  });
}
  
type ExternalDataSourcesSetPriority__MutationParameters = ExternalDataSourcesSetPriorityExternalDataSourcesQueryParameters & {
  body: Types.ExternalDataSourceSetPriorityInput;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalDataSourcesSetPriorityMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ExternalDataSourcesSetPriority__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalDataSourcesSetPriorityExternalDataSourcesQueryParameters}): UseMutationResult<void, unknown, ExternalDataSourcesSetPriority__MutationParameters, TContext> {
  const key = externalDataSourcesSetPriorityMutationKey(options?.parameters?.dataSource!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalDataSourcesSetPriority__MutationParameters) => Client.externalDataSourcesSetPriority(data.dataSource ?? options?.parameters?.dataSource!, data.body),
  mutationKey: key,
});
}